import { useOutletContext } from 'react-router-dom';
import { ErrorPageLayout, PaperLayout } from '../../../../presentation';
import { PolicyPageContainer } from '../policy.page.container';
import { Policy } from '@converge/graphql';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  DocumentListFormSection,
  EndorsementListFormSection,
  PolicyInfoFormSection,
  SubjectivityListFormSection,
} from './form-sections';
import { LoadingButton } from '@mui/lab';
import './policy-entity.detail.overview.scss';

interface IProps {
  policyDetails: Policy;
  policyUuid: string;
}

export const PolicyDetailOverview = () => {
  const { policyDetails } = useOutletContext<IProps>();
  if (!policyDetails) {
    return (
      <ErrorPageLayout
        message="No Policy data found"
        messageId="entity.policy.detail.page.notFound"
      />
    );
  }

  return <PolicyDetailOverviewInner data={policyDetails} />;
};

export const PolicyDetailOverviewInner = ({ data }: { data: Policy }) => {
  const defaultValues = useMemo(() => mapToUIOverviewPolicyModel(data), [data]);

  const formMethods = useForm({
    defaultValues,
  });

  return (
    <PolicyPageContainer
      title="Overview"
      onNext={() => {}}
      footerRight={
        <>
          <LoadingButton
            variant="contained"
            className="footer-button-style"
            color="primary"
          >
            File Claim
          </LoadingButton>
          <LoadingButton
            className="footer-button-style"
            variant="contained"
            color="primary"
          >
            Adjust policy
          </LoadingButton>
          <LoadingButton
            variant="contained"
            className="footer-button-style"
            color="primary"
          >
            Renewal
          </LoadingButton>
          <LoadingButton
            variant="contained"
            className="footer-button-style"
            color="error"
          >
            Cancel
          </LoadingButton>
        </>
      }
    >
      <PaperLayout className="policy-entity-detail-layout">
        <FormProvider {...formMethods}>
          <div className="form-wrapper">
            <PolicyInfoFormSection isReadonly={true} />
            <SubjectivityListFormSection />
            <EndorsementListFormSection />
            <DocumentListFormSection />
          </div>
        </FormProvider>
      </PaperLayout>
    </PolicyPageContainer>
  );
};
const mapToUIOverviewPolicyModel = (policy: Policy) => {
  return {
    uuid: policy.uuid as string,
    referenceId: policy.referenceId ?? '',
    type: policy.type ?? '',
    status: policy.status ?? '',
    stateTax: policy.stateTax,
    policyFee: policy.policyFee,
    stampingFee: policy.stampingFee,
    boundPremium: policy.boundPremium,
    grossPremium: policy.grossPremium,
    netPremium: policy.netPremium,
    startDate: policy.startDate ?? '',
    endDate: policy.endDate ?? '',
    transactionDate: policy.transactionDate ?? '',
    insuredName: policy.insuredName ?? '',
    documentLink: policy.documentLink ?? '',
    createdAt: policy.createdAt ?? '',
    updatedAt: policy.updatedAt ?? '',
  };
};
